import BaseStore from './BaseStore'

export class DepartmentGroupStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'department_groups'
  }
}

export default new DepartmentGroupStore()


// WEBPACK FOOTER //
// ./src/stores/DepartmentGroupStore.js